export enum OptionsTradingLevelEnum {
	ZERO = 0,
	FIRST = 1,
	SECOND = 2,
}
